const LETZTE_UMGEBUNG_KEY = 'etown.letzteUmgebung';

/** Zuletzt betretene Umgebung — eine Geraete-Einstellung wie die Ansicht. */
export function leseLetzteUmgebung(): string | null {
  try {
    return window.localStorage.getItem(LETZTE_UMGEBUNG_KEY);
  } catch {
    return null;
  }
}

export function merkeLetzteUmgebung(umgebungId: string | null): void {
  try {
    if (umgebungId === null) window.localStorage.removeItem(LETZTE_UMGEBUNG_KEY);
    else window.localStorage.setItem(LETZTE_UMGEBUNG_KEY, umgebungId);
  } catch {
    // Privater Modus ohne Speicher: dann eben jedes Mal die Auswahl
  }
}
